import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import tokens from '../theme/tokens';

// 비회원 시작 폼 — 이름·연락처를 넣어야 입력창이 열린다(2026-10-01 사용자 지시). 값은 첫 메시지와 함께 방에 저장돼 다음 방문 때 그대로 불러온다
export const isValidTel = (tel) => /^0\d{8,10}$/.test(String(tel || '').replace(/\D/g, ''));

const useStyles = makeStyles(() => ({
  root: {
    flex: 'none',
    padding: '14px 16px 16px',
    borderTop: `1px solid ${tokens.lineSoft}`,
    backgroundColor: tokens.surface,
  },
  title: {
    marginBottom: 10,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: -0.6,
    color: tokens.ink,
  },
  row: {
    display: 'flex',
    gap: 8,
    marginBottom: 8,
  },
  input: {
    flex: '1 1 0',
    minWidth: 0,
    height: 46,
    padding: '0 14px',
    borderRadius: tokens.radius,
    border: `1px solid ${tokens.line}`,
    backgroundColor: tokens.surface,
    fontSize: 14,
    fontFamily: 'inherit',
    letterSpacing: -0.4,
    color: tokens.ink,
    outline: 'none',
    transition: 'border-color .12s, box-shadow .12s',
    '&:focus': { borderColor: tokens.primary, boxShadow: tokens.shadow },
    '&::placeholder': { color: tokens.placeholder },
  },
  error: {
    marginBottom: 8,
    fontSize: 12,
    letterSpacing: -0.4,
    color: tokens.primaryDark,
  },
  button: {
    width: '100%',
    height: 46,
    borderRadius: 23,
    backgroundColor: tokens.primary,
    color: tokens.surface,
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: -0.6,
    transition: 'background-color .12s',
    '&:hover': { backgroundColor: tokens.primaryDark },
    '&:disabled': { backgroundColor: tokens.line },
  },
}));

function ChatStartForm({ onStart }) {
  const cs = useStyles();
  const [name, setName] = useState('');
  const [tel, setTel] = useState('');
  const [error, setError] = useState('');
  const ready = name.trim().length > 0 && tel.replace(/\D/g, '').length >= 9;

  const submit = (e) => {
    e.preventDefault();
    const n = name.trim();
    const d = tel.replace(/\D/g, '');
    if (!n) { setError('이름을 입력해 주세요.'); return; }
    if (!isValidTel(d)) { setError('연락처를 확인해 주세요.'); return; }
    setError('');
    onStart({ name: n.slice(0, 30), tel: d });
  };

  return (
    <form className={cs.root} onSubmit={submit}>
      <div className={cs.title}>문의자 정보</div>
      <div className={cs.row}>
        <input className={cs.input} value={name} placeholder="이름" maxLength={30} autoComplete="name" onChange={(e) => setName(e.target.value)} aria-label="이름" />
        <input className={cs.input} value={tel} placeholder="연락처" inputMode="tel" maxLength={13} autoComplete="tel" onChange={(e) => setTel(e.target.value)} aria-label="연락처" />
      </div>
      {error && <div className={cs.error}>{error}</div>}
      <ButtonBase type="submit" className={cs.button} disabled={!ready} focusRipple={false}>문의 시작</ButtonBase>
    </form>
  );
}

export default ChatStartForm;
